module.exports = __webpack_public_path__ + "static/media/key.2ad365c0.png";